import { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { app } from "../firebase"; // Ensure you have initialized Firebase in this file

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const auth = getAuth(app);

  // Monitor authentication state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      sessionStorage.setItem("user", JSON.stringify(currentUser?.email));
    });
    return () => unsubscribe();
  }, [auth]);

  // Login function
  const login = async (email, password) => {

      return signInWithEmailAndPassword(auth, email, password);
   
  };

  // Logout function
  const logout = async () => {
    try {
      await signOut(auth);
      console.log("Logout successful");
      
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);